<template>
<div>

    <vue-headful title="Roles :: MeritEHS" />

    <h4 class="py-3 mb-4">
        <ol class="breadcrumb font-weight-bold m-0">
            <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
            <li class="breadcrumb-item active">Roles</li>
            <li class="ml-3">
                <router-link class="btn btn-sm btn-success" to="/admin/role-edit">
                    <i class="fa fa-plus-circle"></i> Add Role
                </router-link>
            </li>
        </ol>
    </h4>

    <div class="card">
        <div class="card-body">
            <v-client-table ref="RolesTable" :data="roles" :columns="columns" :options="options">
                <template slot="name" slot-scope="props" title="Name">
                    <router-link v-if="props.row.SmartBizClientId !== null" :to="`/admin/role-edit/${props.row.id}`">
                        {{ props.row.name }}
                    </router-link>
                    <template v-else>
                        {{ props.row.name }}
                    </template>
                </template>
                <template slot="is_active" slot-scope="props" title="Active">
                    <span class="badge badge-success" v-if="props.row.is_active">Active</span>
                    <span class="badge badge-warning" v-else>Inactive</span>
                </template>

            </v-client-table>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            columns: ['name', 'perms_list', 'description', 'is_active'],
            options: {
                headings: {
                    name: 'Name',
                    perms_list: 'Permissions',
                    description: 'Description',
                    is_active: 'Active',
                }
            },
            roles: [],
        }
    },

    methods: {
        getRolesAndPermissions() {
            //Get the data
            this.$http
                .get('admin/roles')
                .then(response => {
                    //Set all the data
                    this.roles = response.data.data;
                    //Set loading
                    this.loading = false;
                })
                .catch(response => {

                });
        },
    },

    mounted() {
        //Get the injuries
        this.getRolesAndPermissions();
    }
}
</script>
